export enum PigType {
    Weaners = 'WEANERS',
    SlaughterPigs = 'SLAUGHTER_PIGS',
}
